import { SVGObject } from "../svgobject";

export class SVGNature15 extends SVGObject{
    public drawObject():void{
		super.initObject();
        this.svg =`<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 20000303 Stylable//EN" "http://www.w3.org/TR/2000/03/WD-SVG-20000303/DTD/svg-20000303-stylable.dtd"[]><svg xmlns="http://www.w3.org/2000/svg" width="64px" height="64px" viewBox="0 0 512 999"><path style="fill:#ffff80;stroke:#4c4c4c;stroke-width:2" d="M512,999 l-51,-389 -51,56 -52,-223 -51,56 -51,-277 -51,55 -103,-277 -102,55 179,333 51,-28 52,222 51,-55 51,222 51,-56 77,306z" /></svg>`
		super.fillGradients();
        super.drawObject();
    }
}